import { LoadBuilding as LoadBuildComponent, LoadBuildingProvider } from "features/load-building"

export const LoadBuilding = () => (
  <LoadBuildingProvider>
    <LoadBuildComponent />
  </LoadBuildingProvider>
)